import { loggedInUser } from "../types";
import { Auth } from "./auth";

interface ErrorProps {
  default?: boolean;
  type?: string;
  path?: string;
  currentUser?: loggedInUser;
}
export const ErrorRoute = (props: ErrorProps) => {
  if (props.type === "404" && !props.currentUser) {
    return (
      <>
        <h2>Page not found</h2>
        <pre>{props.path}</pre>
        <p>
          You may need to <Auth currentUser={props.currentUser} /> first.
        </p>
        <p>
          Try returning to the <a href="/">Homepage</a>
        </p>
      </>
    );
  }

  return (
    <>
      <h2>Error {props.type}</h2>
      <p>It looks like we hit a snag.</p>
      <pre>{props.path}</pre>
      <p>
        Try returning to the <a href="/">Homepage</a>
      </p>
    </>
  );
};
